import { Injectable, Injector } from '@angular/core';

import { Observable} from 'rxjs';
import { HttpService } from 'projects/core/src/public-api';
import { ProjectAlert } from './alert';
import { AlertResponcePage } from './alert-responce-page';


@Injectable({
    providedIn: 'root',
})
export class AlertService extends HttpService {


    constructor(
        protected injector: Injector
    ) {
        super(injector);
    }

    getActiveAlerts(): Observable<AlertResponcePage> {
        return this.getData(`/alert/list/active`, AlertResponcePage);
    }

}